import _uniqWith from 'lodash/uniqWith';

import { POST_TOUR } from './Constants';

const getInfoLandTour = (days, landTour) => {
  const listDays = days || [];
  const result = [];
  listDays.forEach((element, i) => {
    const ports = element.ports ? element.ports : [];
    ports.forEach(port => {
      if (!result[port.activity]) result[port.activity] = [];
      result[port.activity].push({
        ...port.port,
        type: landTour === POST_TOUR ? element.type : null,
        index: i + 1,
      });
    });
  });

  const landTours = Object.keys(result).map(index => [...result[index]]);

  return {
    // landTours: Array.isArray(landTours) ? landTours.flat() : [],
    landTours: _uniqWith(
      landTours.flat(),
      (a, b) =>
        a.code === b.code && (a.type === b.type || a.index - b.index === 1),
    ),
  };
};
export default getInfoLandTour;
